var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartLoadingContainer',{attrs:{"loading":_vm.loading}},[_c('ChartJSComponent',{staticClass:"full-width full-height",attrs:{"datasets":_vm.datasets,"labels":_vm.labels,"options":_vm.options,"type":_vm.chartType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }